import { render, staticRenderFns } from "./Plan-detail.vue?vue&type=template&id=152e832e"
import script from "./Plan-detail.vue?vue&type=script&lang=js"
export * from "./Plan-detail.vue?vue&type=script&lang=js"
import style0 from "./Plan-detail.vue?vue&type=style&index=0&id=152e832e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports